import { useI18n } from 'core/i18n/I18nProvider';

export function LanguageSwitcher({ onChange }) {
  const { locale, setLocale, t } = useI18n();

  function switchTo(next) {
    setLocale(next);
    onChange?.(next);
  }

  return (
    <div className="lang-switch" role="group" aria-label={t('layout.language')}>
      <button type="button" className={locale === 'ar' ? 'active' : ''} onClick={() => switchTo('ar')}>
        {t('language.ar')}
      </button>
      <button type="button" className={locale === 'en' ? 'active' : ''} onClick={() => switchTo('en')}>
        {t('language.en')}
      </button>
    </div>
  );
}
